export default __webpack_public_path__ + "static/media/truck-transporter.7dceb66e.svg";